import { Button, Modal, Radio } from "antd";
import { useState } from "react";
import { useRecoilState } from "recoil";
import { locationsState } from "../../state/atoms";
import "./CopyFromLocationModal.scss";
import { CloseOutlined, ExclamationCircleOutlined } from "@ant-design/icons";
import { LocationDto } from "../../generated/dashboard-client";

export interface CopyFromLocationModalProps {
  isVisible: boolean;
  onCancel: () => void;
  onConfirm: (locId: number) => void;
  isLoading: boolean;
  activeLocation: LocationDto;
}

export function CopyFromLocationModal({
  isVisible,
  onCancel,
  onConfirm,
  isLoading,
  activeLocation
}: CopyFromLocationModalProps) {
  const [selectedLocId, setSelectedLocId] = useState(0);
  const [locations] = useRecoilState(locationsState);

  return (
    <Modal
      className={"clean one copy-from-location"}
      onCancel={() => onCancel()}
      open={isVisible}
      width={450}
    >
      <header>
        <h2>Copy from location</h2>
        <p>All brand information from the selected location will be copied into the current location.<br />
        <span><ExclamationCircleOutlined /> Brand settings in current location will be overridden.</span></p>
        <CloseOutlined style={{ position: "absolute", right: 15, top: 15, width: 20, height: 20, cursor: "pointer" }} onClick={() => onCancel()} />
      </header>

      <div>
        <Radio.Group onChange={(e) => setSelectedLocId(e.target.value)} value={selectedLocId}>
          {locations.filter(loc => loc.internalId !== activeLocation.internalId)
          .map(loc => {
            return <Radio value={loc.internalId}>{loc.name}</Radio>;
          })}
        </Radio.Group>
      </div>

      <footer>
        <Button size={"large"} onClick={() => onCancel()}>
          Cancel
        </Button>
        <Button size={"large"} className={"primary"} onClick={() => onConfirm(selectedLocId)} loading={isLoading} disabled={!selectedLocId}>
          Done
        </Button>
      </footer>
    </Modal>
  );
}
